import Viewpage from '../components/viewpage/Viewpage';

function PostPage() {
  return <Viewpage />;
}

export default PostPage;
